import { multiply } from 'ramda'
import MessageAlert from 'app/components/MessageAlert'

export const kilobytesToBytes = multiply(1000)
export const megaBytesToBytes = multiply(1000 * 1000)
export const bytesToMegaBytes = (bytes, digits = 3) =>
  `${(bytes / 1000000).toFixed(digits)} MB`
export const bytesToMegaBytesInt = (bytes) => (bytes / 1000000).toFixed(3)
export const kilobytesToMegaBtyes = (kilobytes) =>
  `${(kilobytes / 1000).toFixed(3)} MB`

export const numberToSLUnit = (number) => {
  let eNumber = Math.abs(Number(number))
  if (eNumber >= 1.0e6) {
    return `${(number / 1000000).toFixed(2)}M`
  } else if (eNumber >= 1.0e3) {
    return `${(number / 1000).toFixed(2)}K`
  } else {
    return `${number.toLocaleString()}`
  }
}

export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

export const getWidthHeightFromFile = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      var image = new Image()
      image.src = reader.result
      image.onload = function () {
        resolve({ width: image.width, height: image.height })
      }
    }
    reader.onerror = (error) => reject(error)
  })

export const alertSizeOverLimit = (dispatch, formatMessage, photoSizeLimit) =>
  dispatch(
    MessageAlert.showError({
      message: formatMessage(
        {
          id: 'profile.photo.sizeOverLimit.label',
        },
        { size: bytesToMegaBytes(photoSizeLimit, 0) },
      ),
    }),
  )

export const PHOTO_GALLERY_LIMIT = 50
export const PHOTO_SIZE_LIMIT_10 = megaBytesToBytes(10)
